import styled from 'styled-components';
import _TextNodeModal from 'routes/surface/components/node-modal-form/components/text-node-modal';
import _TextSnippetNodeModal from 'routes/surface/components/node-modal-form/components/text-snippet-node-modal';
import _NoteNodeModal from 'routes/surface/components/node-modal-form/components/note-node-modal';
import _DocumentNodeModal from 'routes/surface/components/node-modal-form/components/document-node-modal';
import _BackgroundNodeModal from 'routes/surface/components/node-modal-form/components/background-node-modal';
import _ProtocolNodeModal from 'routes/surface/components/node-modal-form/components/protocol-node-modal';
import _QuestionnaireNodeModal from 'routes/surface/components/node-modal-form/components/questionnaire-node-modal';
import _QuestionnaireFormModal from 'routes/surface/components/node-modal-form/components/questionnaire-form-modal';
import _ImageNodeModal from 'routes/surface/components/node-modal-form/components/image-node-modal';
import _SurfaceNodeModal from 'routes/surface/components/surface-node-modal';
import _RisSearchModal from 'routes/surface/components/node-modal-form/components/ris-search-modal';
import { color } from 'styles/settings';

export const TextNodeModal = styled(_TextNodeModal)`
  height: 70%;
  max-width: 960px;
`;

export const TextSnippetNodeModal = styled(_TextSnippetNodeModal)`
  height: 70%;
  max-width: 960px;
`;

export const NoteNodeModal = styled(_NoteNodeModal)`
  height: 70%;
  max-width: 960px;
  background-color: ${color.brand.gold};
`;
export const DocumentNodeModal = styled(_DocumentNodeModal)`
  height: auto;
  width: 100%;
  background-color: transparent;
`;

export const BackgroundNodeModal = styled(_BackgroundNodeModal)`
  height: auto;
  width: 100%;
  background-color: transparent;
`;

export const ProtocolNodeModal = styled(_ProtocolNodeModal)`
  max-width: 960px;
`;

export const QuestionnaireNodeModal = styled(_QuestionnaireNodeModal)`
  max-width: 960px;
`;

export const QuestionnaireNodeFormModal = styled(_QuestionnaireFormModal)`
  /* max-width: 2060px; */
`;

export const ImageNodeModal = styled(_ImageNodeModal)`
  height: auto;
  width: 100%;
  background-color: transparent;
`;
export const SurfaceNodeModal = styled(_SurfaceNodeModal)`
  height: 70%;
  max-width: 960px;
`;
export const RisSearchModal = styled(_RisSearchModal)`
  height: 100%;
  width: 100%;
  background-color: transparent;
`;
